export default [
  {isValid: false, description: 'Minimum of 12 characters', regex: /^.{12,}$/}
]
